<template>
    <div class="btn-sm-drop statusbtn" :class="[colorClass, { 'jd-list': isJDList }]">
        <button class="btn btn-secondary">{{ status }}</button>
    </div>
    <!-- <b-dropdown id='ddown1' :text='this.status'
        class='btn-sm-drop statusbtn'
        :class="colorClass"
    >
      <b-dropdown-item
        :disabled="true">
        {{status}}
        </b-dropdown-item>
    </b-dropdown> -->
  </template>

<script>
import { mapGetters } from 'vuex';
export default {
    name: 'StatusBox',
    props: ["status", "isJDList"],
    computed: {
        ...mapGetters({statusColorMap: 'getStatusColorMap'}),
        colorClass(){
            const status = this.status;
            const colorMap = this.statusColorMap;
                for(let color in colorMap){
                    if(colorMap[color].includes(status)){
                        return `${color}`;
                    }
                }S
            return '';
        }
    },
    // methods: {
    //     colorClass() {
    //         const status = this.status;
    //         const colorMap = this.statusColorMap;
    //         console.log(colorMap);
    //             for(let color in colorMap){
    //                 if(colorMap[color].includes(status)){
    //                     console.log(color);
    //                     return `${color}`;
    //                 }
    //             }
    //         return '';
    //     },
    // },
    // mounted(){
    //     this.colorClass();
    // }
}
</script>

<style scoped>
.jd-list button {
    min-width: 130px;
    font-size: 12px !important;
}

.btn.btn-secondary {
  font-size: 14px;
}
.pink button {
  color: #fff;
  background-color: #b97070;
  border-color: #b97070;
}
.grey button {
  color: #fff;
  background-color: #ab8371;
  border-color: #ab8371;
}
.green button {
  color: #fff;
  background-color: #5bb55b;
  border-color: #5bb55b;
}
.lightblue button {
  color: #fff;
  background-color: #7070af;
  border-color: #7070af;
}
.lightgreen button {
  color: #fff;
  background-color: #7ba27b;
  border-color: #7ba27b;
}
.red button {
  color: #fff;
  background-color: #ab8371;
  border-color: #ab8371;
}
.yellow button{
  color: #000;
  background-color: #ffea00;
  border-color: #ffea00;
}
</style>
  
  